<div class="container-fluid padMob webViewBack padZero" style="padding-left: 10px; padding-right: 10px;">
    <div class="row bg mobView">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 padHeder divHeader"  style="padding-bottom: 10px;">
            <span style="font-size: 22px; margin-right: 10px; display: inline-block; cursor: pointer;" (click)="goBack();"><i class="fa fa-chevron-left"></i></span>
            <h4 class="modalHeader" style="display: inline-block; color: #555;">Production Stages</h4>    
            <span style="float: right;">
                <span class="orangeButton" (click)="open(mdlStageEntry)" style="padding: 4px 9px !important; line-height: 17px;">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px;"></i>
                </span>
                <span style="cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; display: inline !important; margin-left: 10px; display: none !important;" class="webView closeMdl brdrRadius3" (click)="goBack();">
                    <i class="zmdi zmdi-close"></i>
                </span>
            </span>
        </div>

        <div class="col-md-12 col-12 col-sm-12 headerPadding DivPad">        
            <div class="col-md-12 col-12 col-sm-12" style="padding-bottom: 10px; padding-left: 15px;">
                <div class="col-md-12 col-12 col-sm-12" style="font-size: 15px; padding-left: 0px;">
                    <span style="color: #333; font-size: 18px;  ">
                        {{prductData.productName}}
                    </span>  
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 5px; text-align: right; display: none;">
                <span class="orangeButton" (click)="open(mdlStageEntry)">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 18px; vertical-align: bottom; margin-right: 5px;"></i>
                    <span style="font-size: 14px;">Add Stage</span>
                </span>
            </div>

            <!-- Stage List -->
            <div class="col-md-12 col-12 col-sm-12 pad0" style="padding-top: 10px; margin-bottom: 5px;">
                <div *ngIf="selectedStages.length > 0" style="padding: 0px 15px;">
                    <div class="bgWhite pad15" *ngFor="let s of selectedStages; let i = index" 
                    style="padding: 10px; margin-top: 5px; border: 1px solid #f0f0f0;">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0 font13">
                            <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk">
                                <span>{{s.SNm}}</span>
                            </div>
                            <div class="col-md-4 col-4 col-sm-4 pad0 inLneBlk txtRight">
                                <span class="lableBtnGray brdrRadius3" style="padding: 1px 6px; font-size: 13px;"><i class="fa fa-trash-o" (click)="removeStage(i)"></i></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="" style="padding-top: 15px;"  *ngIf="selectedStages.length == 0">
                    <div class="nrf brdrRadius3" (click)="open(mdlStageEntry);" style="margin-left: 15px;">
                        Click here to add a stage to your process flow.
                    </div>
                </div>

                <div class="col-md-6 col-6 col-sm-6" style="text-align: left; margin-top: 10px; margin-left: 75px;">
                    <span style="font-size: 14px;">OR</span>
                </div>

                <div class="" style="margin-top: 10px;" *ngIf="selectedStages.length == 0">
                    <div class="nrf brdrRadius3" (click)="open(mdlStageFlowEntry);" style="margin-left: 15px;">
                        Click here to add a stage flow.
                    </div>
                </div>
            </div>

            <!-- Stage Save -->
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px;">
                <div class="btn btn-darkGreen brdrRadius3" style="line-height: 18px; padding: 5px 10px; margin-right: 10px;" (click)="saveStages();" *ngIf="selectedStages.length > 0">
                    <i class="fa fa-check"></i> Save
                </div>
                <div class="btn-mdlClose brdrRadius3" (click)="goBack();">
                    <i class="fa fa-close"></i> Close
                </div>
            </div>
        </div>
       
    </div>

    <div class="row HeadDiv webView">
        <div style="color: #006400; font-size: 16px;">
            <span style="font-weight: bold;">{{ isProjectType ? 'Project' : 'Production' }} Stages</span>
            <span class="btn-darkGreen" style="float: right; font-size: 15px; cursor: pointer; margin-left: 5px; border-radius: 3px; padding: 1px 7px 1px;" *ngIf="(!isEdit) && (selectedStages.length == 0) && !isProjectType" (click)="copyFromProduct()"><i class="zmdi zmdi-copy"></i></span>
            <span class="lableBtnDarkGreen" style="float: right; cursor: pointer; padding: 2px 9px; font-size: 15px; margin-left: 5px;" (click)="open(mdlStageEntry)" *ngIf="isEdit"><i class="zmdi zmdi-plus"></i></span>
            <span class="btn-darkGreen" style="float: right; font-size: 15px; cursor: pointer; margin-left: 5px; border-radius: 3px; padding: 1px 7px 1px;" *ngIf="!isEdit && right.InvMstrs && !isProjectType" (click)="isEditTrue()"><i class="fa fa-pencil"></i></span>
            <div class="btn darkGreenButton brdrRadius3" style="padding: 4px 8px 3px !important; font-size: 13px;float: right;margin-right: 5px;" (click)="saveStages();" *ngIf="(isEdit) && (selectedStages.length > 0)">
                <i class="fa fa-check"></i> Save
            </div>
            <!-- <span style="float: right; font-size: 20px; cursor: pointer;" (click)="fn_OpenBOM();" class="mobView"><i class="zmdi zmdi-plus"></i></span> -->
        </div>

        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px;">        
            <!-- Stage List -->
            <div class="col-md-12 col-12 col-sm-12 pad0" style="padding-top: 10px;">
                <div class="marginTp" *ngIf="selectedStages.length > 0">
                    <div mat-cell *ngFor="let s of selectedStages; let i = index" style="padding: 5px; {{ i % 2 == 0 ? 'background-color: #f5f5f5;' : 'background-color: #fff;' }}">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0">
                            <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk" style="font-size: 14px;">
                                <span>{{s.SNm}}</span>
                            </div>
                            <div class="col-md-4 col-4 col-sm-4 pad0 inLneBlk txtRight" *ngIf="isEdit">
                                <span class="lableBtnGray brdrRadius3" title="Remove Stage" style="padding: 2px 7px 2px;"><i class="fa fa-trash-o" (click)="removeStage(i)"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="col-md-12 col-12 col-sm-12 pad0" style="padding-top: 10px;">
                <div class="marginTp" *ngIf="selectedStages.length > 0">
                    <table class="stage-table">
                        <tbody>
                            <tr *ngFor="let s of selectedStages; let i = index">
                                <td class="stage-name">{{ s.SNm }}</td>
                                <td class="stage-action" *ngIf="isEdit">
                                    <span 
                                        class="lableBtnGray brdrRadius3" 
                                        title="Remove Stage" 
                                        (click)="removeStage(i)">
                                        <i class="fa fa-trash-o"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
            

            <!-- Stage Save -->
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; padding-left: 0px;" *ngIf="isEdit">
                <div class="btn darkGreenButton brdrRadius3" style="padding: 2px 7px 2px;font-size: 14px;margin-right: 5px;" (click)="saveStages();" *ngIf="selectedStages.length > 0">
                    <i class="fa fa-check"></i> Save
                </div>
                <div class="btn btn-gray brdrRadius3" style="padding: 2px 7px 2px;font-size: 14px;margin-right: 5px;line-height: 1.66em;" (click)="cancelStages();" *ngIf="selectedStages.length > 0">
                    <i class="fa fa-times"></i> Cancel
                </div>
            </div>
        </div>

        <div *ngIf="selectedStages.length == 0 && !isProjectType">
            <div class="nrf brdrRadius3" (click)="open(mdlStageEntry);" style="margin-top: 15px; cursor: pointer;">
                Click here to add a stage to your process flow.
            </div>
        </div>

        <div *ngIf="selectedStages.length == 0" class="col-md-6 col-6 col-sm-6" style="text-align: left; margin-top: 10px; margin-left: 75px;">
            <span style="font-size: 14px;">OR</span>
        </div>

        <div *ngIf="right.InvMstrs && selectedStages.length == 0">
            <div class="nrf brdrRadius3" (click)="open(mdlStageFlowEntry);" style="margin-top: 10px; cursor: pointer;">
                Click here to add a stage flow.
            </div>
        </div>
    </div>
</div>

 <!-- Stage Entry Level Modal -->
 <ng-template #mdlStageEntry let-modal>     
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr">Select Stage</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right; margin-top: 2px; padding: 6px 10px !important;" (click)="closeModalStage($event)"></i>
                    <span class="lableBtnDarkGreen" title ="Add Stage" style="float: right; font-size: 15px; margin-right: 5px; padding: 2px 10px; cursor: pointer; margin-left: 5px;" (click)="openStageConfig();">
                        <i class="zmdi zmdi-plus"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding: 0px; padding-bottom: 15px;">
       <div>
            <!-- <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder" style="padding: 15px;">
                <h4 style="display: inline-block;">Select Stage</h4>    
                <span style="float: right;" data-dismiss="modal" (click)="closeModal()"  >
                    <i class="closeMdl zmdi zmdi-close" style="float: right;"></i>
                </span>
            </div>      -->
            
            <div class="col-md-12 col-12 col-sm-12" style="padding-right: 20px;">
                <div>
                    <!-- <input class="form-control" list="stageList" [(ngModel)]="stageEntry.stageName" 
                        placeholder="Select Stage" (blur)="fn_ChangeStage();">
                    <datalist id="stageList">                        
                        <option *ngFor="let s of stageList;" [value]="s.SNm">{{s.SNm}}</option>
                    </datalist> -->
                    <select class="label Bluebadge form-control" [(ngModel)]="stageEntry.stageName" (ngModelChange)="fn_ChangeStage()" style="font-size: 13px;">
                        <option value="" selected>Select</option>
                        <option *ngFor="let s of stageList" [ngValue]="s.SNm">{{s.SNm}}</option> 
                    </select>
                </div>
            </div>

            <div class="col-md-12 col-12 col-sm-12" style="margin-top: 20px;">
                <div class="btn-green brdrRadius3" style="padding: 0px 10px; font-size: 15px; line-height: 30px;" (click)="addNewStages();">
                    <i class="fa fa-check"></i> Save
                </div>
            </div>
       </div>
    </div>
</ng-template>

 <!-- Stage Flow Level Modal -->
 <ng-template #mdlStageFlowEntry let-modal>     
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr">Select Stage Flow</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right; margin-top: 2px; padding: 6px 10px !important;" (click)="closeModalStage($event)"></i>
                </div>
            </div>
        </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding: 0px; padding-bottom: 15px;">
       <div>
            <!-- <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder" style="padding: 15px;">
                <h4 style="display: inline-block;">Select Stage</h4>    
                <span style="float: right;" data-dismiss="modal" (click)="closeModal()"  >
                    <i class="closeMdl zmdi zmdi-close" style="float: right;"></i>
                </span>
            </div>      -->
            
            <div class="col-md-12 col-12 col-sm-12" style="padding-right: 20px;">
                <div>
                    <!-- <input class="form-control" list="stageList" [(ngModel)]="stageEntry.stageName" 
                        placeholder="Select Stage" (blur)="fn_ChangeStage();">
                    <datalist id="stageList">                        
                        <option *ngFor="let s of stageList;" [value]="s.SNm">{{s.SNm}}</option>
                    </datalist> -->
                    <select class="label Bluebadge form-control" [(ngModel)]="stageFlowName" style="font-size: 13px;">
                        <option value="" selected>Select</option>
                        <option *ngFor="let s of stageFlowList" [ngValue]="s.StageFlow">{{s.StageFlow}}</option> 
                    </select>
                </div>
            </div>

            <div class="col-md-12 col-12 col-sm-12" style="margin-top: 20px;">
                <div class="btn-green brdrRadius3" style="padding: 0px 10px; font-size: 15px; line-height: 30px;" (click)="displayStageNames();">
                    <i class="fa fa-check"></i> Save
                </div>
            </div>
       </div>
    </div>
</ng-template>